import React from 'react'
import AboutHero from '../../components/AboutComponets/AboutHero'
import OurStory from '../../components/AboutComponets/OurStory'
import MissionVision from '../../components/AboutComponets/MissionVision'
// import TeamSection from '../../components/AboutComponets/TeamSection'
import WhatWeDo from '../../components/HomeComponents/what-we-do'
// import TimelineSection from '../../components/AboutComponets/TimelineSection'

const About = () => {
  return (
    <div className="my-10 py-10 sm:p-10">
      <AboutHero />
      <OurStory />
      <MissionVision />
      {/* <TeamSection /> */}
      <WhatWeDo />
      {/* <TimelineSection /> */}
    </div>
  )
}

export default About